export default __webpack_public_path__ + "static/media/sign-image.219f00c9.svg";